export class ToolInstance {
    public readonly instanceId: string;
    public readonly toolId: string;
    public time: number;

    private onSetTime?: ((time:number) => void);

    constructor(instanceId: string, toolId: string, time: number, setTimeCallback?: ((time: number) => void)) {
        this.instanceId = instanceId;
        this.toolId = toolId;
        this.time = time;
        this.onSetTime = setTimeCallback;
    }

    public setTime(time: number | string) {
        if (typeof time === 'string') {
            time = parseInt(time, 10) || 0;
        }
        time = Math.max(Math.min(time, 999), 0);
        this.time = time;
        if (this.onSetTime !== undefined) {
            this.onSetTime(time);
        }
    };
};



// WEBPACK FOOTER //
// ./src/App/ToolInstance.ts